export default __webpack_public_path__ + "static/media/managepr_navicon.c2f97393.svg";